/**
 * Created by neo on 26.02.17.
 */
import React, { Component } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { translate  } from 'react-i18next';
import FlightOffer from '../../Store/FlightOffer';
import { Alert, Row, Col, Button, FormGroup, Label } from 'reactstrap';
import FlightOfferCard from './FlightOfferCard';
import LanguageStore from '../../../lang';
import DisplayToggle from '../../Components/DisplayToggle';
import Settings from '../../Store/Settings';

@observer
export class FlightOfferSection extends React.Component<any, void> {
  @observable response: any = { first: true, last: true };
  @observable loading: boolean = true;
  @observable firstLoad: boolean = true;
  @observable flightOffers: Array<FlightOffer> = [];
  @observable page: number = 1;

  constructor(props) {
    super(props);

    this.requestFlightOffer = new FlightOffer({
      title: props.t('Request a Flight'),
    });
  }

  componentDidMount() {
    this.load(this.page);
  }

  componentWillReceiveProps(newProps) {

    if (newProps.locations != this.props.locations) {
      this.flightOffers = [];
      this.load(this.page, newProps.locations);
    }

  }

  async load(page?: number, locations?: array) {
    this.loading = true;
    this.response = await FlightOffer.load(page, LanguageStore.lang, locations || this.props.locations);
    this.flightOffers = this.flightOffers.concat(this.response.content);
    this.loading = false;
    this.firstLoad = false;

    if (this.flightOffers.length) {
      const randomIndex = Math.floor(Math.random() * this.flightOffers.length);
      this.requestFlightOffer.files = this.flightOffers[randomIndex].files;
    }
  }

  handleClick = (flightOffer: FlightOffer) => {
  };

  handleLoadMore = () => {
    this.page += 1;
    this.load(this.page);
  };

  render() {
    const { props: { t }, loading, page, firstLoad, response, flightOffers } = this;

    if (flightOffers.length === 0) {
      return null;
    }

    const { settings } = Settings;

    return (
      <Row>
        <Col>
          <Row>
            <Col>
              <h1>{t('Unsere Angebote')}</h1>
            </Col>
          </Row>
          <DisplayToggle show={!loading || !firstLoad}>
            <Row>
              {flightOffers.map((f, i) => (
                <Col key={i} xs='12' md='6' lg='4' className='mb-4'>
                  <FlightOfferCard flightOffer={f} onClick={this.handleClick} />
                </Col>
              ))}
              {settings.has('enable_flight_requests') && settings.get('enable_flight_requests') > 0 &&
                <Col xs='12' md='6' lg='4' className='mb-4'>
                  <div>
                    <FlightOfferCard
                      flightOffer={this.requestFlightOffer}
                      onClick={this.handleClick}
                      link='/request-flight'
                    />
                  </div>
                </Col>
              }
            </Row>
          </DisplayToggle>
          <DisplayToggle show={loading && firstLoad}>
            <Row>
              <Col>
                <Alert color='info'>{t('Unsere Flugangebote werden gerade geladen')}</Alert>
              </Col>
            </Row>
          </DisplayToggle>
          <DisplayToggle show={!firstLoad && !response.last}>
            <Row>
              <Col className='d-flex justify-content-center'>
                <div className='pt-5 pb-5'>
                  <Button
                    color='secondary'
                    size='lg'
                    onClick={this.handleLoadMore}
                    block
                    disabled={loading}
                  >
                    {t('Weitere Angebote laden')}
                  </Button>
                </div>
              </Col>
            </Row>
          </DisplayToggle>
          <DisplayToggle show={!loading && !flightOffers.length}>
            <Row>
              <Col>
                <Alert color='warning'>
                  {t('Zurzeit bieten wir leider keine Flugangebote an')}
                </Alert>
              </Col>
            </Row>
          </DisplayToggle>
        </Col>
      </Row>
    );
  }
}

export default translate ()(FlightOfferSection);



// WEBPACK FOOTER //
// ./src/App/Dashboard/FlightOffer/index.js